import { ListItemText } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const CustomListItemText = withStyles(() => ({
  root: {
    flex: 'unset',
    whiteSpace: 'pre-wrap',
  },
}))(ListItemText)

export default CustomListItemText
